<template>
	<div class="suggestions">
		<div class="wrapper">
			<div class="suggestion" tabindex="1" v-for="value in values" :data-key="value.key"  @mousedown="suggestionClicked(value)">{{ value.value }}</div>
		</div>
	</div>
</template>

<script>
export default {
	setup() {
	},
	emits: ["suggestion-clicked"],
	props: {
		values: {
			type: Array,
			required: true,
		},
	},
	name: "SuggestionsList",
	data() {
		return {
		}
	},
	methods: {
		suggestionClicked( k ) {
			this.$emit("suggestion-clicked", k);
		}
	}
}
</script>

<style scoped lang="scss">
.suggestions {
	background-color: var(--color-bg-primary-2);
	font-size: 13px;
	.wrapper {
		overflow: hidden;
		border-radius: 13px;
		border-color: var(--color-primary);
		border-width: 1px;
		border-style: solid;

		.suggestion {
			background-color: var(--color-bg);
			position: relative;

			&:after {
				content: ' ';
				position: absolute;
				z-index: 3;
				top: 0;
				width: 100%;
				left: 0;
				height: 100%;
				background: $alpha_1;
				opacity: 0;
				transition: opacity .1s cubic-bezier(.66,.12,.21,1);
			}

			&:hover {
				cursor: pointer;

				&:after {
					opacity: 1;
				}
			}

			padding: 14px;
		}
	}
}
</style>
